import { useQuery } from '@tanstack/react-query';
import { iconStore } from './types';

export const useFetchIconByName = (name: string) => {
	return useQuery(['icon', name], () => {
		return iconStore[name] ?? { name: 'default' };
	});
};
